$(document).ready(function () {
	var isPBZ = $('html').attr('data-bank').toUpperCase() == 'PBZ';
	var isCIB = $('html').attr('data-bank').toUpperCase() == 'CIB';
	var isAlex = $('html').attr('data-bank').toUpperCase() == 'ALEX';
	var isSLO = isSloveniaBank();
	var isBIB = $('html').attr('data-bank').toUpperCase() == 'BIB';
	var isISPBIH = $('html').attr('data-bank').toUpperCase() == 'ISPBIH';
	if (isPBZ || isCIB || isSLO || isBIB || isAlex || isISPBIH){
		var formSendFeedback = $(".microsite_formFeedback");
		console.log("send feedback");
		if(formSendFeedback.length > 0){
			console.log("send feedback");
			onSubmitClick();
			hideCustomComponentsInstantFeedbackPage();
		}
	}
});


function hideCustomComponentsInstantFeedbackPage(){
	
	var isCIB = $('html').attr('data-bank').toUpperCase() == 'CIB';
	var instantFeedbackPage = $(".instantFeedbackPage").length > 0;
	var checkShowMessage = $(".shownFormInstantFeedback").length > 0;
	if(isCIB && instantFeedbackPage){
		if(!checkShowMessage){
			$(".surveyInstantFeedbackCheck").each(function (){
				$(this).hide();
			});
		}
	}
}



function submitCommentFeedbackDefault (){
	var isCIB = $('html').attr('data-bank').toUpperCase() == 'CIB';
	var isBIB = $('html').attr('data-bank').toUpperCase() == 'BIB';
	var isISPBIH = $('html').attr('data-bank').toUpperCase() == 'ISPBIH';
	var newComment = "";
	var comment = $("#comment");
	var date = $("#IDdatePickerMicrosite");
	var period = $("#periodMeeting");
	var channel = $("#channel");
	var itemComment = $("#item_comment");
	if(isCIB){
		if(date.length > 0){
			if(date.val().length > 0) {
				newComment = newComment.concat("Date:").concat(date.val().concat(" ")); 	
			}	
		}
		if(period.length > 0){
			if(period.val().length > 0) {
				newComment =  newComment.concat("Time:").concat(period.val().concat(" ")); 
			}	
		}
		if(channel.length > 0){
			if(channel.val().length > 0) {
				newComment =  newComment.concat("Contact channel:").concat(channel.val().concat(" "));
			}	
		}
		if(itemComment.length > 0){
			if(itemComment.val().length > 0) {
				newComment =  newComment.concat("Comment:").concat(itemComment.val().concat(" "));
			}	
		}
		if(newComment.length > 0){
			comment.val(newComment);
			console.log(newComment);	
		}	
	} else if(isISPBIH){
		if(date.length > 0){
			if(date.val().length > 0) {
				newComment = newComment.concat("Datum:").concat(date.val().concat(" ")); 	
			}	
		}
		if(period.length > 0){
			if(period.val().length > 0) {
				newComment =  newComment.concat("Vrijeme:").concat(period.val().concat(" ")); 
			}	
		}
		if(channel.length > 0){
			if(channel.val().length > 0) {
				newComment =  newComment.concat("Kontakt kanal:").concat(channel.val().concat(" "));
			}	
		}
		if (itemComment.length > 0) {
            if (itemComment.val().length > 0) {
                newComment = newComment.concat("Komentar:").concat(itemComment.val().concat(" "));
            }
        }
		if(newComment.length > 0){
			comment.val(newComment);
			console.log(newComment);	
		}	
	} else {
		
		if (isBIB) {
			
			var actualLang = "";
			
			try{
				actualLang = window.dataLayer[0]["siteLanguage"];
			} catch(e) {
				actualLang = "En";
			}
			
			var channelLabel = actualLang == "En" ? "Channel:" : "Kanal:";
			var commentLabel = actualLang == "En" ? "Comment:" : "Komentar:";
			
			if(channel){
				if(channel.find(":selected").text().length > 0) {
					newComment =  newComment.concat(channelLabel).concat(channel.find(":selected").val().concat(" "));
				}
			}
			
			if(itemComment.length > 0){
				if(itemComment.val().length > 0) {
					newComment =  newComment.concat(commentLabel).concat(itemComment.val().concat(" "));
				}	
			}
			
		} else {
			
			if(itemComment.length > 0){
				if(itemComment.val().length > 0) {
					newComment =  newComment.concat("Comment:").concat(itemComment.val().concat(" "));
				}	
			}
			
		}
		
				
		if(newComment.length > 0){
			comment.val(newComment);
			console.log(newComment);	
		}	
		
	}
}
function submitCommentFeedbackPbz (){
	var isPBZ = $('html').attr('data-bank').toUpperCase() == 'PBZ';
	var comment = $("#comment");
	var newComment = "";
	var conuntryPrefix = "";
	var phoneNumber = "";
	var itemComment = $("#item_comment");
	if(isPBZ){
		$(".micrositePBZinput").each(function (){
			var val = $(this).val();
			var typeInput = $(this).attr("input-type");
			if (typeInput == "phoneNumber" ){
				if($(this).attr("name") == "countryPrefix"){
					conuntryPrefix = val;
				}else{
					phoneNumber = val;
				}
			}else{
				if(val != ''){
					newComment = newComment.concat($(this).attr("input-type")).concat(":").concat(val).concat(" ");
				}
			} 
			console.log("val input ->",val);
		});		


		if(conuntryPrefix.length > 0 || phoneNumber.length > 0){

			phone = conuntryPrefix.concat(" "+phoneNumber);

			newComment = newComment.concat("phoneNumber").concat(":").concat(phone).concat(" ");

		}
		
		if(itemComment.length > 0){
			if(itemComment.val().length > 0) {
				newComment =  newComment.concat("Comment:").concat(itemComment.val().concat(" "));
			}	
		}

		if(newComment.length > 0){
			comment.val(newComment);
			console.log(newComment);
		}
	}
}



function onSubmitClick(){
	$(".js-button-feedback").on("click" ,function () {
		var isPBZ = $('html').attr('data-bank').toUpperCase() == 'PBZ';
		var button = $(this);
		var thankButton = button.attr("data-thankyou");
		var valueButton = button.attr("data-value");
		var thankElement = $("#thankyou");
		var valueElement = $("#value");
		var comment = $("#comment");
		var date = $("#IDdatePickerMicrosite");
		var period = $("#period");
		var channel = $("#channel");
		console.log("inner on submit click");
		console.log("button:",button);
		console.log("thankButton:",thankButton);
		console.log("buttonValue:",valueButton);
		if(!$(this).hasClass("btn-secondary")){
			thankElement.val(thankButton.toString());
			valueElement.val(valueButton);
			var commentTemplate = $("#commentTemplate").val();
			if(commentTemplate!= null && commentTemplate != "" && commentTemplate != undefined ){
				if(date){
					commentTemplate = commentTemplate.replace('{date}' , date.val());
					console.log("inner date");
				}
				if(period){
					commentTemplate = commentTemplate.replace('{period}' , period.val());
					console.log("inner period");
				}
				if(channel){
					commentTemplate = commentTemplate.replace('{channel}' , channel.val());
					console.log("inner channel");
				}
				
				if (valueElement.val() == "4") {
					  commentTemplate = button.text();
					  console.log("commentTemplate:",commentTemplate);
					}
				submitCommentFeedbackDefault();
				$(".microsite_formFeedback").submit();
			}else if(isPBZ){
				thankElement.val(thankButton.toString());
				valueElement.val(valueButton);
				submitCommentFeedbackPbz();
				$(".microsite_formFeedback").submit();
			} else {
				submitCommentFeedbackDefault();
				$(".microsite_formFeedback").submit();
			}
		}else{
			thankElement.val(thankButton.toString());
			valueElement.val(valueButton)
			channel.val(null);
			$(".microsite_formFeedback").submit();
		}
		
	});
}

function isSloveniaBank() {
	return $('html').attr('data-bank').toUpperCase() == 'ISPSLOVENIA';
}